import { render, staticRenderFns } from "./Pass.vue?vue&type=template&id=30abe9d6&scoped=true"
import script from "./Pass.vue?vue&type=script&lang=js"
export * from "./Pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30abe9d6",
  null
  
)

export default component.exports